const NumberStepInputComponent = ({
  suffix,
  value,
  onValueChange,
  isDisabled = false,
  placeholder,
  inputClass,
}: {
  suffix: string;
  value: string | number;
  isDisabled?: boolean;
  onValueChange: React.ChangeEventHandler<HTMLInputElement>;
  placeholder?: string;
  inputClass?: string;
}) => {
  return (
    <div className="flex justify-end items-center border border-darwin-neutral-100 rounded-4 py-8 px-12">
      <input
        type="number"
        step={0.1}
        min={0}
        value={value.toString()}
        onChange={onValueChange}
        disabled={isDisabled}
        placeholder={placeholder}
        className={inputClass}
      />
      <div>{suffix}</div>
    </div>
  );
};

export default NumberStepInputComponent;
